module.exports = __webpack_public_path__ + "img/preview-laptop-EN.454b8fb2.jpeg";